"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Laptop1: ['laptop-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.5,14.734a1,1,0,0,0,1-1V5.418a.667.667,0,0,1,.667-.667H18.833a.667.667,0,0,1,.667.667v8.316a1,1,0,1,0,2,0V5.418a2.669,2.669,0,0,0-2.667-2.667H5.167A2.669,2.669,0,0,0,2.5,5.418v8.316A1,1,0,0,0,3.5,14.734Z', 'M23.894,16.443a.5.5,0,0,0-.394-.192h-8a.5.5,0,0,0-.5.5c0,.71-1.232,1.5-3,1.5s-3-.79-3-1.5a.5.5,0,0,0-.5-.5H.5a.5.5,0,0,0-.485.621,5.773,5.773,0,0,0,5.608,4.379H18.377a5.773,5.773,0,0,0,5.608-4.379A.5.5,0,0,0,23.894,16.443Z']],
  Laptop: ['laptop', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.3,20.691l-2.1-6.83a1.486,1.486,0,0,0-.339-.56,2.639,2.639,0,0,0,.643-1.717V2.918A2.669,2.669,0,0,0,18.831.251H5.164A2.67,2.67,0,0,0,2.5,2.918v8.666A2.64,2.64,0,0,0,3.141,13.3a1.486,1.486,0,0,0-.339.56L.728,20.615a2.167,2.167,0,0,0,1.938,3.136H21.328a2.153,2.153,0,0,0,1.844-1.028A2.1,2.1,0,0,0,23.3,20.691Zm-7.793.457a.5.5,0,0,1-.4.208H8.9a.5.5,0,0,1-.474-.658l.6-1.8a.5.5,0,0,1,.474-.342h5a.5.5,0,0,1,.475.342l.6,1.8A.5.5,0,0,1,15.5,21.148ZM4.5,2.918a.667.667,0,0,1,.667-.667H18.831a.667.667,0,0,1,.666.667v8.666a.667.667,0,0,1-.666.667H5.164a.667.667,0,0,1-.667-.667Z']],
  LaptopSmiley1: ['laptop-smiley-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.468,14.734a1,1,0,0,0,1-1V5.418a.667.667,0,0,1,.667-.667H18.8a.667.667,0,0,1,.667.667v8.316a1,1,0,0,0,2,0V5.418A2.67,2.67,0,0,0,18.8,2.751H5.135A2.669,2.669,0,0,0,2.468,5.418v8.316A1,1,0,0,0,3.468,14.734Z', 'M23.9,16.443a.5.5,0,0,0-.395-.192h-8a.5.5,0,0,0-.5.5c0,.71-1.232,1.5-3,1.5s-3-.79-3-1.5a.5.5,0,0,0-.5-.5H.5a.5.5,0,0,0-.485.621,5.773,5.773,0,0,0,5.608,4.379H18.377a5.773,5.773,0,0,0,5.608-4.379A.5.5,0,0,0,23.9,16.443Z', 'M9.469,9.4a.75.75,0,0,0,.75-.75V7.5a.75.75,0,1,0-1.5,0V8.645A.75.75,0,0,0,9.469,9.4Z', 'M15.219,8.645V7.5a.75.75,0,1,0-1.5,0V8.645a.75.75,0,0,0,1.5,0Z', 'M7.66,11.359a.75.75,0,0,0,0,1.061,6.249,6.249,0,0,0,8.839,0,.75.75,0,0,0-1.061-1.061,4.748,4.748,0,0,1-6.717,0A.75.75,0,0,0,7.66,11.359Z']],
  Laptop2: ['laptop-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.5,16.751h17a.5.5,0,0,0,.489-.4l2.74-12.79a1.5,1.5,0,0,0-1.466-1.814H4.309A1.507,1.507,0,0,0,2.842,2.936L.011,16.146a.5.5,0,0,0,.489.605Zm7-8a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,7.5,8.751Z', 'M23.5,18.251H.5a.5.5,0,0,0-.5.5v1a2.5,2.5,0,0,0,2.5,2.5h19a2.5,2.5,0,0,0,2.5-2.5v-1A.5.5,0,0,0,23.5,18.251Z']],
  LaptopLock1: ['laptop-lock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.985,16.872a.5.5,0,0,0-.485-.621h-8a.5.5,0,0,0-.5.5c0,.71-1.232,1.5-3,1.5s-3-.79-3-1.5a.5.5,0,0,0-.5-.5H.5a.5.5,0,0,0-.485.621,5.772,5.772,0,0,0,5.608,4.379H18.377A5.773,5.773,0,0,0,23.985,16.872Z', 'M11.968,5.5a2.753,2.753,0,0,0-2.75,2.75v.572a.251.251,0,0,1-.107.205,1.49,1.49,0,0,0-.643,1.223v3a1.5,1.5,0,0,0,1.5,1.5h4a1.5,1.5,0,0,0,1.5-1.5v-3a1.49,1.49,0,0,0-.643-1.223.251.251,0,0,1-.107-.205V8.251A2.752,2.752,0,0,0,11.968,5.5Zm1,6.269a1,1,0,1,1-1-1A1,1,0,0,1,12.968,11.77Zm-2.25-3.519a1.25,1.25,0,0,1,2.5,0,.25.25,0,0,1-.25.25h-2A.25.25,0,0,1,10.718,8.251Z', 'M3.468,14.751a1,1,0,0,0,1-1v-8a1,1,0,0,1,1-1h13a1,1,0,0,1,1,1v8a1,1,0,1,0,2,0v-8a3,3,0,0,0-3-3h-13a3,3,0,0,0-3,3v8A1,1,0,0,0,3.468,14.751Z']],
  LaptopLock: ['laptop-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,17.751a.5.5,0,0,0-.5-.5h-8a.5.5,0,0,0-.5.5V18a.25.25,0,0,1-.25.25h-3.5A.25.25,0,0,1,10,18v-.25a.5.5,0,0,0-.5-.5h-8a.5.5,0,0,0-.5.5v2a1.5,1.5,0,0,0,1.5,1.5h19a1.5,1.5,0,0,0,1.5-1.5Z', 'M12,6a2.753,2.753,0,0,0-2.75,2.75v.572a.251.251,0,0,1-.107.205A1.49,1.49,0,0,0,8.5,10.751v3a1.5,1.5,0,0,0,1.5,1.5h4a1.5,1.5,0,0,0,1.5-1.5v-3a1.49,1.49,0,0,0-.643-1.223.251.251,0,0,1-.107-.205V8.751A2.752,2.752,0,0,0,12,6Zm1,6.269a1,1,0,1,1-1-1A1,1,0,0,1,13,12.27ZM10.75,8.751a1.25,1.25,0,0,1,2.5,0A.25.25,0,0,1,13,9H11A.25.25,0,0,1,10.75,8.751Z', 'M3.5,15.751a1,1,0,0,0,1-1v-9a1,1,0,0,1,1-1h13a1,1,0,0,1,1,1v9a1,1,0,0,0,2,0v-9a3,3,0,0,0-3-3H5.5a3,3,0,0,0-3,3v9A1,1,0,0,0,3.5,15.751Z']],
  LaptopSmiley: ['laptop-smiley', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,9.4a.75.75,0,0,0,.75-.75V7.5a.75.75,0,0,0-1.5,0V8.645A.75.75,0,0,0,9.5,9.4Z', 'M15.25,8.645V7.5a.75.75,0,0,0-1.5,0V8.645a.75.75,0,0,0,1.5,0Z', 'M7.691,11.359a.75.75,0,0,0,0,1.061,6.249,6.249,0,0,0,8.839,0,.75.75,0,0,0-1.06-1.061,4.749,4.749,0,0,1-6.718,0A.75.75,0,0,0,7.691,11.359Z', 'M23,17.751a.5.5,0,0,0-.5-.5h-8a.5.5,0,0,0-.5.5V18a.25.25,0,0,1-.25.25h-3.5A.25.25,0,0,1,10,18v-.25a.5.5,0,0,0-.5-.5h-8a.5.5,0,0,0-.5.5v2a1.5,1.5,0,0,0,1.5,1.5h19a1.5,1.5,0,0,0,1.5-1.5Z', 'M3.5,15.751a1,1,0,0,0,1-1v-9a1,1,0,0,1,1-1h13a1,1,0,0,1,1,1v9a1,1,0,0,0,2,0v-9a3,3,0,0,0-3-3H5.5a3,3,0,0,0-3,3v9A1,1,0,0,0,3.5,15.751Z']]
};
exports["default"] = _default;